module.exports = {
  listOrganizations: "listOrganizations",
  createOrganizations: "createOrganizations",
  deleteOrganizations: "deleteOrganizations",
  updateOrganizations: "updateOrganizations",
  viewOrganizations: "viewOrganizations",
  createCompanies: "createCompanies",
  createApplications: "createApplications",
  listAreas: "listAreas",
  listManagers: "listManagers",
  assignManagers: "assignManagers",
  unassignManagers: "unassignManagers",
  listCompanies: "listCompanies",
  listApplications: "listApplications",
  deactivateCompanies: "deactivateCompanies",
  activateCompanies: "activateCompanies",
  assignApplications: "assignApplications",
  unassignApplications: "unassignApplications",
  deleteCompanies: "deleteCompanies",
  updateCompanies: "updateCompanies",
  viewCompanies: "viewCompanies",
  listCompanyAreas: "listCompanyAreas",
  assignCompanies: "assignCompanies",
  unassignCompanies: "unassignCompanies",
  deleteApplications: "deleteApplications",
  activateApplications: "activateApplications",
  deactivateApplications: "deactivateApplications",
  copyAreas: "copyAreas",
  updateApplications: "updateApplications",
  viewApplications: "viewApplications",
  listAreaCompanies: "listAreaCompanies",
  listApplicationAreas: "listApplicationAreas",
  viewAreas: "viewAreas",
  assignAreasCompanies: "assignAreasCompanies",
  unassignAreasCompanies: "unassignAreasCompanies",
  assignTagsAreas: "assignTagsAreas",
  createAreas: "createAreas",
  updateAreas: "updateAreas",
  deleteAreas: "deleteAreas",
  listApplicationCompanies: "listApplicationCompanies",
  statisticsOrganizations: "statisticsOrganizations",
  statisticsCompanies: "statisticsCompanies",
  statisticsApplications: "statisticsApplications",
  listApplicaitonTags: "listApplicaitonTags",
  viewPromo: "viewPromo",
  addPromo: "addPromo",
  assignPromoToCompanies: "assignPromoToCompanies",
  unAssignPromoFromCompanies: "unAssignPromoFromCompanies",
  validatePromoCode: "validatePromoCode",
  listPromos: "listPromos",
  pausePromo: "pausePromo",
  resumePromo: "resumePromo",
  updatePromo: "updatePromo",
  deletePois: "deletePois",
  addPoi: "addPoi",
  listPois: "listPois",
  updatePoi: "updatePoi",
  generateInvoice: "generateInvoice",
  creditNoteInvoice: "creditNoteInvoice",
  viewInvoice: "viewInvoice",
  listInvoices: "listInvoices",
  resendInvoice: "resendInvoice",
  createClientTaxProfile: "createClientTaxProfile",
  viewClientTaxProfile: "viewClientTaxProfile",
  updateClientTaxProfile: "updateClientTaxProfile",
  deleteClientTaxProfile: "deleteClientTaxProfile",
  listClientTaxProfile: "listClientTaxProfile",
  listApplicationTrips: "listApplicationTrips",
  listApplicationTripsDetails: "listApplicationTripsDetails",
  listCompanyTrips: "listCompanyTrips",
  listCompanyTripsDetails: "listCompanyTripsDetails",
  listApplicationUsers: "listApplicationUsers",
  listApplicationClientTrips: "listApplicationClientTrips",
  viewApplicationClientTrip: "viewApplicationClientTrip",
  blockClient: "blockClient",
  listCompanyTransactions: "listCompanyTransactions",
  listApplicationTransactions: "listApplicationTransactions",
  viewCompanyTransactionDetails: "viewCompanyTransactionDetails",
  viewApplicationTransactionDetails: "viewApplicationTransactionDetails",
  reExecuteFailedApplicationTripTransaction:
    "reExecuteFailedApplicationTripTransaction",
  reExecuteFailedCompanyTripTransaction:
    "reExecuteFailedCompanyTripTransaction",
  unpauseVoucher: "unpauseVoucher",
  pauseVoucher: "pauseVoucher",
  viewVoucher: "viewVoucher",
  addVoucher: "addVoucher",
  listVoucher: "listVoucher",
  updateVoucher: "updateVoucher",
  deleteVoucher: "deleteVoucher",
  exportVoucherCodes: "exportVoucherCodes",
  assignVoucherCompanies: "assignVoucherCompanies",
  unassignVoucherCompanies: "unassignVoucherCompanies",
  listVoucherCompanies: "listVoucherCompanies",
  listCompanyVouchers: "listCompanyVouchers",
  addCompanyCancellationPolicy: "addCompanyCancellationPolicy",
  listCompanyCancellationPolicy: "listCompanyCancellationPolicy",
  getCompanyCancellationPolicy: "getCompanyCancellationPolicy",
  updateCompanyCancellationPolicy: "updateCompanyCancellationPolicy",
  getApplicationUserDetails: "getApplicationUserDetails",
  listCompanyPromos: "listCompanyPromos",
  sendActivationMailToClient: "sendActivationMailToClient",
  activateClient: "activateClient",
  unblockClient: "unblockClient",
  sendResetPassToClient: "sendResetPassToClient",
  sendActivationSMSToClient: "sendActivationSMSToClient",
  createZone: "createZone",
  listZones: "listZones",
  updateZone: "updateZone",
  deleteZone: "deleteZone",
  listCompanyZones: "listCompanyZones",
  getApplicationZoneCompanies: "getApplicationZoneCompanies",
  getApplicationZoneAreas: "getApplicationZoneAreas",
  getCompanyZoneAreas: "getCompanyZoneAreas",
  assignZoneCompanies: "assignZoneCompanies",
  deactivateApplicationUser: "deactivateApplicationUser",
};
